export default "__VITE_ASSET__0bf3ab86__"